// @flow @jsx h

import { h } from 'preact'
import styles from './PositionIndicator.css'
import type { Answers, Questions } from '../../types'

type Props = {
  answers: Answers,
  questions: Questions,
  path: string,
  questionNumber: number
}

const PositionIndicator = ({ answers, questions, questionNumber }: Props) => {
  const target = questions.length

  return (
    <div class={styles['position-indicator__container']}>
      <span class={styles['position-indicator']}>
        {questionNumber + 1} av {target}
      </span>
    </div>
  )
}
export { PositionIndicator }



// WEBPACK FOOTER //
// ./src/v1/components/Overlay/PositionIndicator.js